import { render } from "./QuizMe.vue?vue&type=template&id=3552d19e"
import script from "./QuizMe.vue?vue&type=script&lang=js"
export * from "./QuizMe.vue?vue&type=script&lang=js"

import "./QuizMe.vue?vue&type=style&index=0&id=3552d19e&lang=css"

import exportComponent from "/Users/andrewderse/Documents/repos/gal-scroll-viewer-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__